import { pathOr } from 'ramda';

import { setPage } from './setPage';
import { getTermValue, resetTerms, setTerm, TJsonQuery } from '../../../../packages/JsonQuery';
import { selectMapBounds } from '../../../Map/selectors';
import { IPublicWebV1SearchResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { fetchListingOffers } from '../../services/listing/fetchListingOffers';
import { ITypedReduxAction, TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { justChangeJsonQuery } from '../filters/justChangeJsonQuery';
import { EOffersFetchingMode } from '../listingModal';

export enum ELoadListingActionTypes {
  Request = 'loadListingOffers/request',
  Success = 'loadListingOffers/success',
  Failure = 'loadListingOffers/failure',
}

export type TRequestListingOffers = ITypedReduxAction<ELoadListingActionTypes.Request>;
export type TSuccessListingOffers = ITypedReduxAction<ELoadListingActionTypes.Success, IPublicWebV1SearchResponse>;
export type TFailureListingOffers = ITypedReduxAction<ELoadListingActionTypes.Failure>;

export const requestListingOffers: () => TRequestListingOffers = actionGenerator<ELoadListingActionTypes.Request>(
  ELoadListingActionTypes.Request,
);

export const successListingOffers: (data: IPublicWebV1SearchResponse) => TSuccessListingOffers = actionGenerator<
  ELoadListingActionTypes.Success,
  IPublicWebV1SearchResponse
>(ELoadListingActionTypes.Success);

export const failureListingOffers: () => TFailureListingOffers = actionGenerator<ELoadListingActionTypes.Failure>(
  ELoadListingActionTypes.Failure,
);

export const loadListingOffers =
  ({
    nextPage = false,
    offersFetchingMode = EOffersFetchingMode.ALL,
  }): TThunkAction<Promise<IPublicWebV1SearchResponse>> =>
  async (dispatch, getState, context) => {
    const { logger } = context;
    const state = getState();
    const { queryString } = state;
    let { jsonQuery } = state.filters;
    const { bounds } = selectMapBounds(state);

    if (nextPage) {
      const page = pathOr(1, ['listingOffers', 'page'], state);
      jsonQuery = setTerm('page')(jsonQuery)(page + 1);
    } else {
      jsonQuery = setTerm('page')(jsonQuery)(1);
    }

    let jsonQueryToFetch = jsonQuery;

    if (bounds) {
      // нужно поменять местами широту и долготу, иначе search-engine выдает неправильный результат
      const reversedBounds = bounds.map(b => b.slice().reverse()) as [YMaps.TCoord, YMaps.TCoord];
      jsonQueryToFetch = setTerm('bbox')(jsonQuery)(reversedBounds);
    }

    if (offersFetchingMode === EOffersFetchingMode.SINGLE) {
      const idToFetch = state.listingModal.activeOfferId;
      jsonQueryToFetch = setTerm('id')(jsonQuery)(idToFetch);
    }

    try {
      dispatch(requestListingOffers());
      /*
       * отправляем queryString, чтобы после ответа бэка не терялись utm-метки из урлы
       * подробности в задаче https://jira.cian.tech/browse/CD-191441
       */
      const result = await fetchListingOffers(context, {
        jsonQuery: jsonQueryToFetch,
        queryString,
      });

      let nextJsonQuery = result.jsonQuery as TJsonQuery;
      nextJsonQuery = resetTerms(['bbox', 'id'])(nextJsonQuery);
      const nextPage = getTermValue('page')(nextJsonQuery) || 1;

      dispatch(successListingOffers(result));
      dispatch(justChangeJsonQuery({ nextJsonQuery }));
      dispatch(setPage(nextPage));

      return result;
    } catch (error) {
      dispatch(failureListingOffers());
      logger.error(error);

      throw error;
    }
  };
